import React, { useEffect, useState } from 'react';
import { view } from '@forge/bridge';

import Configuration from './configuration/Configuration';
import View from './view/View';

export const EntryPointResolver = () => {
    const [entryPoint, setEntryPoint] = useState();

    useEffect(() => {
        document.body.style.overflowY = '';
        void view.getContext().then(context => setEntryPoint(context.extension.entryPoint || 'view'));
    }, []);

    return (
        entryPoint ? <>
            {
                entryPoint === 'edit'
                    ? <Configuration />
                    : <View />
            }
        </> : null
    );
};

